const ageLimit = () => {
	const btn = document.querySelector('[data-cookie="age-limit"]');
	const ageLimitContainer = document.querySelector('.catalog-content');
	const createCookie = (name, value) => {
		document.cookie = `${name}=${value};`;
	}

	if (btn) {
		btn.onclick = (e) => {
			createCookie('ageLimit', true);

			if(!ageLimitContainer.classList.contains('with-age-limit')) {
				ageLimitContainer.classList.add('with-age-limit')
			}

			Catalog.reload();

			e.preventDefault();
		}
	}
}

ageLimit();

export default ageLimit;
